module.exports = __webpack_public_path__ + "img/CLion_icon.6ac5766a.png";